__turbopack_context__.v({
  "container": "ActionCard-module__3D7EYa__container",
  "declineButton": "ActionCard-module__3D7EYa__declineButton",
  "primaryButton": "ActionCard-module__3D7EYa__primaryButton",
});
